import React, { useContext } from 'react';
import './PackageBannerMobileComponent.css';
import { Context } from '../../AppContext';

const PackageBannerMobileComponent = ({ packageData }) => {
  const { trackTemplateEvent } = useContext(Context);
  const { mweb_banner } = packageData;
  const usps = mweb_banner.usps || [];
  return (
    <>
      <div
        onClick={() => {
          if (mweb_banner.redirection_url)
            window.location.href = mweb_banner.redirection_url;
          trackTemplateEvent(`Cab_SEO_Packages_Mobile_Banner_Clicked`);
        }}
        className="makeFlex packageDataSection"
      >
        <div className="makeBlock packageDataSectionInfo">
          <div className="packageDataTitle">{mweb_banner.title}</div>
          <div className="packageDataSubtitle">
            {mweb_banner.city_sub_title}
          </div>
        </div>
        <div className="packageDataViewCabsButton">
          <div className="packageDataCTA">View</div>
          <div className="packageDataArrow">{`>`}</div>
        </div>
      </div>

      <div className="makeFlex packageDataUsp">
        <div className="makeFlex packageDataUspItemList">
          {usps.map((usp, index) => (
            <React.Fragment key={index}>
              <div className="packageDataUspItem">{usp}</div>
              {index < usps.length - 1 && (
                <div className="packageDataBullet"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default PackageBannerMobileComponent;
